<template>
  <section id="intro" class="w-full flex flex-col items-center justify-center pt-24 pb-16 bg-gradient-to-b from-white to-slate-50">
    <div class="max-w-screen-lg w-full px-6 text-center">
      <img :src="logo" class="h-12 mx-auto mb-6" alt="Uttrly logo" />

      <h1 class="text-3xl md:text-5xl font-semibold tracking-tight text-slate-900">
        Proposal for {{ project.name }}
      </h1>
      <p class="text-base md:text-lg mt-2 text-slate-600">
        {{ project.address }}
      </p>

      <!-- primary actions -->
      <div class="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
        <!-- utility buttons -->
        <div class="flex items-center justify-center gap-3 order-2 sm:order-1">
          <BaseButton
            variant="base"
            :disabled="isPending"
            @click="$emit('download')"
          >
            <span class="i-heroicons-arrow-down-tray" />
          </BaseButton>

          <BaseButton
            variant="base"
            :disabled="isPending"
            @click="$emit('print')"
          >
            <span class="i-heroicons-printer" />
          </BaseButton>

          <BaseButton
            variant="base"
            text="Request Question"
            :disabled="isPending"
            @click="$emit('question')"
          />
        </div>

        <!-- accept / decline or status -->
        <div class="flex items-center justify-center gap-3 order-1 sm:order-2">
          <!-- awaiting response buttons -->
          <BaseButton
            v-if="proposal.status === PROPOSAL_STATUS.AWAITING_ACCEPTANCE && !isPending"
            variant="primary"
            text="Accept"
            :disabled="preview"
            @click="$emit('open-signature')"
          />
          <BaseButton
            v-if="proposal.status === PROPOSAL_STATUS.AWAITING_ACCEPTANCE && !isPending"
            variant="danger"
            text="Decline"
            :disabled="preview"
            @click="$emit('decline')"
          />

          <!-- status badge -->
          <ProposalStatusBadge
            v-if="!isPending && proposal.status !== PROPOSAL_STATUS.AWAITING_ACCEPTANCE"
            :status="proposal.status"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Proposal, PROPOSAL_STATUS } from '@/models/proposal'
import { Project } from '@/models/project'
import BaseButton from '@/components/base/BaseButton.vue'
import ProposalStatusBadge from './ProposalStatusBadge.vue'
import logo from '@/assets/images/logo.png'

interface Props {
  project: Project
  proposal: Proposal
  isPending: boolean
  preview: boolean
}

defineProps<Props>()

defineEmits(['open-signature', 'decline', 'print', 'download', 'question'])
</script> 